
'use strict';

var ManufacturersTabs = require('./manufacturers-tabs');

// Create manufacturers tabs
new ManufacturersTabs({
  el: '#ManufacturersTabs'
});



// WEBPACK FOOTER //
// ./assets/js/manufacturers/manufacturers.js